import axios from 'axios';
import React, { useEffect, useState } from 'react';
import language from '../../variables/language';

const TYPE_LABELS = {
  info: 'Інформація',
  function: 'Результат',
  state: 'Статус',
};

export const Infopanel = (props) => {
  const [sets, setSets] = useState({});

  useEffect(() => {
    axios.get(props.url, { withCredentials: true })
      .then(response => {
        if (response.data && Array.isArray(response.data)) {
          const grouped = response.data.reduce((acc, part) => {
            if (!acc[part.type]) {
              acc[part.type] = [];
            }

            acc[part.type].push(part);
            return acc;
          }, {});

          setSets(grouped);
        }
      })
      .catch(err => console.error(err));
  }, [props.url]);

  return (
    <div className='infopanel-container'>
      {Object.keys(sets).length > 0 &&
        Object.entries(sets).map(([type, items]) => (
          <div key={type} className='infopanel-plate' data-type={type}>
            <p className='infopanel-plate-title'>{TYPE_LABELS[type] || type}</p>
            {items.map(item => (
              <div key={item.id} className='infopanel-part'>
                <span>
                  {language[language.lang][item.name]
                    ? language[language.lang][item.name]
                    : item.name}
                </span>
                <p>{item.value}</p>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};
